import returnInvoiceCover from 'src/assets/Buy_Policy_Images/returnInvoiceCover.svg'
import personalAccidentCover from 'src/assets/Buy_Policy_Images/personalAccidentCover.svg'
import roadsideAssistanceCover from 'src/assets/Buy_Policy_Images/roadsideAssistanceCover.svg'
import zeroDeprecationCover from 'src/assets/Buy_Policy_Images/zeroDeprecationCover.svg'
import engineProtectionCover from 'src/assets/Buy_Policy_Images/engineProtectionCover.svg'
import consumablesCover from 'src/assets/Buy_Policy_Images/consumablesCover.svg'
import vpAccidental from 'src/assets/viewPlanMotor/vpAccidental.svg'
import vpConsequental from 'src/assets/viewPlanMotor/vpConsequental.svg'
import vpFire from 'src/assets/viewPlanMotor/vpFire.svg'
import vpIllegal from 'src/assets/viewPlanMotor/vpIllegal.svg'
import vpManMade from 'src/assets/viewPlanMotor/vpManMade.svg'
import vpMechanical from 'src/assets/viewPlanMotor/vpMechanical.svg'
import vpNatural from 'src/assets/viewPlanMotor/vpNatural.svg'
import vpTheft from 'src/assets/viewPlanMotor/vpTheft.svg'
import vpThirdParty from 'src/assets/viewPlanMotor/vpThirdParty.svg'
import vpTransit from 'src/assets/viewPlanMotor/vpTransit.svg'
import vpWar from 'src/assets/viewPlanMotor/vpWar.svg'
import vpWT from 'src/assets/viewPlanMotor/vpWT.svg'
import InfoLogo from 'src/assets/Buy_Policy_Images/info.svg'
import ShieldLogo from 'src/assets/Buy_Policy_Images/shield.svg'
import UserUmbrellaLogo from 'src/assets/Buy_Policy_Images/userUmbrella.svg'
import StatLogo from 'src/assets/Buy_Policy_Images/stat.svg'

export const Form_Error_Msgs = {
  Name_Msg: 'Name is required',
  Mobile_Msg: 'Mobile Number is required',
  Address_Msg: 'Address is requried',
  City_Msg: 'City is requried',
  State_Msg: 'State is requried',
  Pincode_Msg: 'Pincode is requried',
}

export const POLICY_TYPE_BIKE = {
  THIRD_PARTY: 'THIRD_PARTY',
  COMPREHENSIVE: 'COMPREHENSIVE',
  OWNDAMAGE: 'OWN_DAMAGE',
}

export const POLICY_TYPE_BIKE_EXPIRY = {
  EXPIRED: 'expired',
  NOT_EXPIRED: 'notExpired',
}

export const insuranceCoverHeading =
  'Here are some value-for-money add-on covers for bike insurance'

export const insuranceCoverHeadingText =
  // prettier-ignore
  'Selecting the most suitable add-ons depends on your individual needs, riding habits, and the area you live in. It\'s essential to evaluate your requirements and choose add-on covers that enhance the protection of your bike without significantly increasing the premium. Always discuss with your insurance provider to understand the add-ons and their benefits better.'

export const addOnCoversList = [
  {
    image: zeroDeprecationCover,
    title: 'Zero (Nil) Depreciation Cover',
    text: 'This cover ensures that the insured gets the full claim without any deduction for depreciation on the value of replaced parts.',
  },
  {
    image: roadsideAssistanceCover,
    title: 'Roadside Assistance Cover',
    text: 'Provides assistance like towing, fuel delivery, flat tire repair, battery jump-start, and other emergency services in case of breakdowns.',
  },
  {
    image: engineProtectionCover,
    title: 'Engine Protection Cover',
    text: 'Covers damages to the engine and its parts due to water ingression, leakage of lubricating oil, or damages during flooding.',
  },
  {
    image: consumablesCover,
    title: 'Consumables Cover',
    text: 'Covers the cost of consumable items like nuts, bolts, engine oil, lubricants, etc., which are not usually covered in a standard policy.',
  },
  {
    image: returnInvoiceCover,
    title: 'Return to Invoice Cover',
    text: 'Ensures that you receive the invoice value of the bike, including registration and road tax, in case of total loss or theft.',
  },
  {
    image: personalAccidentCover,
    title: 'Personal Accident Cover for Pillion Rider',
    text: 'Extends personal accident coverage to the pillion rider, providing them financial protection in case of accidental death or disability.',
  },
]

export const BIKE_INSURANCE_FEATURES = [
  {
    title: 'Add PA Cover',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
  {
    title: 'Zero Depreciation',
    content: '',
    toolTipText:// prettier-ignore
      'Only covers damage or injury caused to others by your vehicle. Doesn\'t cover damages to your own vehicle or injuries to you. Consider comprehensive insurance for full protection.',
  },
]

export const VEHICLE_TYPE = {
  TWO_WHEELER: 'TWO_WHEELER',
  FOUR_WHEELER: 'FOUR_WHEELER',
  UNKNOWN: 'UNKNOWN',
}

export const VEHICLE_TYPE_TEXT = {
  TWO_WHEELER: 'Two Wheeler',
  FOUR_WHEELER: 'Four Wheeler',
  UNKNOWN: 'Unknown',
}

export const viewPlanCoveredBike = [
  {
    id: 'cover_1',
    logo: vpAccidental,
    text: 'Bike Accidents',
    toolTipText:
      'Protects your bike from accidents, theft, natural disasters, manmade incidents, fire, explosions, or transit-related damages.',
  },
  {
    id: 'cover_2',
    logo: vpTheft,
    text: 'Bike theft',
    toolTipText:
      'This policy safeguards against losses arising from the unfortunate theft of your bike',
  },
  {
    id: 'cover_3',
    logo: vpNatural,
    text: 'Damage from natural disasters (like floods or storms)',
    toolTipText:
      'This policy provides coverage for damages to your bike and losses resulting from natural calamities like cyclones, floods, and earthquakes.',
  },
  {
    id: 'cover_4',
    logo: vpManMade,
    text: 'Damage from human-made dangers (like vandalism)',
    toolTipText:
      'This policy offers coverage for damages to your bike and losses resulting from man-made hazards like terrorist attacks or fires.',
  },
  {
    id: 'cover_5',
    logo: vpFire,
    text: 'Loss from fires and explosions',
    toolTipText:
      'This policy covers damages and losses to your bike caused by accidental fires.',
  },
  {
    id: 'cover_6',
    logo: vpTransit,
    text: 'Damage during transportation',
    toolTipText:
      'This policy covers damages and losses to your bike that occur during transit from one place to another.',
  },
]

export const viewPlanNotCoveredBike = [
  {
    id: 'notCovered_1',
    logo: vpWT,
    text: 'Regular use wear and tear',
    toolTipText:
      'Any losses resulting from the usual wear and tear of the vehicle will not qualify for a claim.',
  },
  {
    id: 'notCovered_2',
    logo: vpThirdParty,
    text: 'Damage to third party',
    toolTipText:
      'This policy does not cover damages to third parties, including other individuals, vehicles, or properties involved in the accident.',
  },
  {
    id: 'notCovered_3',
    logo: vpMechanical,
    text: 'Machinery breakdown',
    toolTipText:
      'Mechanical or electrical breakdowns, failure of chassis or body parts, and breakage due to rust or weather conditions are not eligible for claims under this policy.',
  },
  {
    id: 'notCovered_4',
    logo: vpConsequental,
    text: 'Resulting damage',
    toolTipText:
      'Any damage not directly resulting from the claimed accident, such as additional harm caused to the engine while driving the damaged bike post-accident, is not covered under this policy.',
  },
  {
    id: 'notCovered_5',
    logo: vpIllegal,
    text: 'Unlawful driving and activities',
    toolTipText:// prettier-ignore
      'Your claim won\'t be approved if the driver didn\'t have a valid license, was under the influence of intoxicating substances, used the bike for commercial purposes, or was involved in racing during the accident. Deliberate damage or damage occurring during riots involving you also disqualifies your claim.',
  },
  {
    id: 'notCovered_6',
    logo: vpWar,
    text: 'Harm caused by war or invasion',
    toolTipText:// prettier-ignore
      'This policy doesn\'t cover losses resulting directly or indirectly from war, invasion, acts of foreign enemies, hostilities, civil war, mutiny, rebellion, or military actions.',
  },
]

export const ruleData = [
  {
    id: '1',
    logo: InfoLogo,
    text: // prettier-ignore
    'Bike Insurance shouldn\'t be viewed as a mandatory document for driving your vehicle. It\'s a financial safety net, helping you manage unexpected expenses.',
  },
  {
    id: '2',
    logo: ShieldLogo,
    text: 'In an unfortunate scenario, only comprehensive insurance covers your vehicle in the event of an accident, theft, fire, or natural disaster.',
  },
  {
    id: '3',
    logo: UserUmbrellaLogo,
    text: 'Third-Party Insurance is mandatory for all vehicles in Bharath. It covers damage to their property and medical bills, up to Rs. 7.5 lakhs. ',
  },
  {
    id: '4',
    logo: StatLogo,
    text: // prettier-ignore
    'Third-Party Insurance - in case of a fatality in an accident, compensation is provided based on the court\'s decision',
  },
]
